import { useCreditConfig } from '../../../contexts/CreditConfigContext';
import { COSTS } from './mvData';

const PRO_AUDIO_MODEL = 'lyria-3-pro-preview';

export default function useMvCredits(values) {
  const { getLyricsGenerationCost, getAudioGenerationCost } = useCreditConfig();
  const lyrics = getLyricsGenerationCost();
  const music = getAudioGenerationCost({
    audioModel: PRO_AUDIO_MODEL,
    duration: values.duration,
  });

  return {
    lyrics: validCost(lyrics, COSTS.lyrics),
    music: validCost(music, COSTS.music),
    video: COSTS.video,
  };
}

function validCost(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}
